import { render, staticRenderFns } from "./TLightButton.vue?vue&type=template&id=71994690&"
import script from "./TLightButton.vue?vue&type=script&lang=js&"
export * from "./TLightButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports